import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

function SMSLogs() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>SMS Messages</Typography>
      <Paper sx={{ p: 3 }}>
        <Typography color="textSecondary">
          SMS message logs will appear here.
        </Typography>
      </Paper>
    </Box>
  );
}

export default SMSLogs;
